import React, { useRef, useEffect, useState } from 'react';

import Navigation from './Navigation';

export default function OutsideAlerter() {
  const ref = useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // @ts-ignore Tried with `event: Event`, but `contains` function is not compatible with `target` type
  const handleClickOutside = event => {
    if (isMenuOpen && ref.current && !ref.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <span ref={ref}>
      <Navigation isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
    </span>
  );
}
